import { PropertyCard } from 'components/Property'
import { usePropertiesQuery } from 'hooks/usePropertiesQuery'
import { ComponentType } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { Col, Container, Row } from 'reactstrap'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'
import { RoleModel } from 'utils/role'

const Wrapper = styled.div`
  padding-bottom: 120px;

  ${up('sm')} {
    padding-bottom: 78px;
  }
`

interface Props {
  property: any
  role: RoleModel
  category: any
  zone: any
}

export const Related: ComponentType<Props> = ({ property, role, category, zone }) => {
  const { formatMessage } = useIntl()

  const { data } = usePropertiesQuery({
    variables: {
      query: {
        'uuid!': property.uuid,
        role: role.query,
        category: category?.uuid,
        zone: zone?.uuid,
        limit: 5,
      },
    },
  })

  return (
    <Wrapper>
      <Container className="print--none">
        <Row>
          <Col>
            <h6 className="font-size-14 font-weight-bold text-uppercase text-primary mb-15">Propiedades similares</h6>
            <h3 className="font-size-26 font-family-serif font-weight-bold mb-10">
              <FormattedMessage
                id="property.related.title"
                values={{
                  role: role ? formatMessage({ id: role.uuid }) : 'en venta y renta',
                  category: category?.pluralName ?? 'Propiedades',
                  zone: zone?.name ?? 'Mérida y Yucatán',
                }}
              />
            </h3>
          </Col>
        </Row>
        <div className="five-row">
          {data?.properties?.data.map((property: any) => (
            <div key={property.uuid} className="five-col-sm-1 py-24">
              <PropertyCard property={property} className="h-100" />
            </div>
          ))}
        </div>
      </Container>
    </Wrapper>
  )
}
